export default __webpack_public_path__ + "static/media/logout-tether.94f86dfc.svg";